module.exports = __webpack_public_path__ + "static/media/photo-4-m.797b86d7.jpeg";